'use client';

import React, { useMemo } from 'react';

import ProductListingPage from 'components/consumer/ProductListingPage';
import useQuickshipPageData from './hooks/useQuickshipPageData';

const ConsumerQuickshipPage = () => {
  const pageData = useQuickshipPageData();
  const pageDataWithLayout = useMemo(
    () => ({
      ...pageData,
      layout: 'minimal-with-attributes',
    }),
    [pageData]
  );
  return <ProductListingPage pageData={pageDataWithLayout} />;
};

export default ConsumerQuickshipPage;
